// The "x" glyph in the Denied/Not Selected badges (Figma "Icon_DeniedNotSelected_X").
export default function BadgeXIcon({
  width = 6,
  height = 6,
  fill = '#AA222D',
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 6 6' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M5.87143 0.128571C5.7 -0.0428572 5.44285 -0.0428572 5.27142 0.128571L3 2.4L0.728577 0.128571C0.557149 -0.0428572 0.3 -0.0428572 0.128571 0.128571C-0.0428571 0.3 -0.0428571 0.557143 0.128571 0.728572L2.39999 3L0.128571 5.27143C-0.0428571 5.44286 -0.0428571 5.7 0.128571 5.87143C0.214285 5.95714 0.299988 6 0.428559 6C0.557131 6 0.642863 5.95714 0.728577 5.87143L3 3.6L5.27142 5.87143C5.35714 5.95714 5.48573 6 5.57144 6C5.65716 6 5.78572 5.95714 5.87143 5.87143C6.04286 5.7 6.04286 5.44286 5.87143 5.27143L3.60001 3L5.87143 0.728572C6.04286 0.557143 6.04286 0.3 5.87143 0.128571Z'
        fill={fill}
      />
    </svg>
  );
}
